module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }